let DaysIntense = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.addForm();
        this.delete();
    },

    addForm: function () {
        let _this = this;

        let daysIntenseForm = $('#daysIntenseForm');

        if (daysIntenseForm.length) {
            let submitBtn = Ladda.create(daysIntenseForm.find('[type=submit]')[0]);
            let dateFormat = 'dd/mm/yyyy';

            let startDate = $('#diStartDate').datepicker({
                startDate: 'now',
                format: dateFormat,
            });
            let endDate = $('#diEndDate').datepicker({
                format: dateFormat,
            });

            daysIntenseForm.ajaxForm({
                beforeSubmit: function () {
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        window.location.reload();
                    }
                    else {
                        submitBtn.stop();
                    }
                },
                error: function () {
                    submitBtn.stop();
                }
            });
        }
    },

    delete: function () {
        $('.delete-days-intense').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/days-intense/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    _getDate: function (element, dateFormat) {
        let date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        }
        catch (error) {
            date = null;
        }

        return date;
    }
};

$().ready(function () {
    window.DaysIntense = DaysIntense;
    window.DaysIntense.init();
});